export default {
  portfolio: {
    title: 'Projelerimiz',
    projects: {
      ai_valuation: 'Yapay zeka ile gayrimenkul değerlendirmesi',
      price_prediction: 'Fiyat tahmini',
      district_analysis: 'İlçe bazında pazar analizi',
      report_automation: 'Rapor otomasyonu',
      developer_api_integration: 'Müteahhit API entegrasyonu',
      investment_index: 'Yatırım çekiciliği endeksleri'
    }
  }
}
